/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalityIdListModel
 */
export interface LocalityIdListModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof LocalityIdListModel
     */
    localities: Array<number>;
}

export function LocalityIdListModelFromJSON(json: any): LocalityIdListModel {
    return LocalityIdListModelFromJSONTyped(json, false);
}

export function LocalityIdListModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalityIdListModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'localities': json['localities'],
    };
}

export function LocalityIdListModelToJSON(value?: LocalityIdListModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'localities': value.localities,
    };
}

